const ServicesPageComponent = {
    data() {
        return {
            tabs: [],
            groups: [],
            activeProfessionId: 0,
            loading: false,
        };
    },

    computed: {
        activeTitle() {
            if (Number(this.activeProfessionId) === 0) {
                return 'Все услуги';
            }

            const t = (this.tabs || []).find(x => Number(x.id) === Number(this.activeProfessionId));
            return t?.title || 'Услуги';
        },

        activeServices() {
            const pid = Number(this.activeProfessionId) || 0;

            if (pid === 0) {
                const all = [];

                for (const g of (this.groups || [])) {
                    for (const it of (g.items || [])) {
                        all.push(it);
                    }
                }

                return all;
            }

            const g = (this.groups || []).find(x => Number(x.id) === pid);
            return g?.items || [];
        },
    },

    methods: {
        async getServicesPage() {
            this.loading = true;

            try {
                const response = await window.servicesPageService.getServicesPage({});

                this.tabs = response?.data?.tabs ?? [];
                this.groups = response?.data?.groups ?? [];

                // дефолт: "Все"
                this.activeProfessionId = 0;

            } catch (e) {
                console.error('[ServicesPage] getServicesPage failed', e);

                this.tabs = [];
                this.groups = [];
                this.activeProfessionId = 0;
            } finally {
                this.loading = false;
            }
        },

        setProfession(id) {
            this.activeProfessionId = Number(id) || 0;
        },

        formatPrice(v) {
            const n = Number(v || 0);
            return n.toLocaleString('ru-RU');
        },

        formatIndex(idx) {
            const n = Number(idx) + 1;
            return String(n).padStart(2, '0');
        },
    },

    mounted() {
        this.getServicesPage();
    },
};

window.ServicesPageComponent = ServicesPageComponent;